import React, { Fragment, useEffect } from "react";
import { Mui, omitReduxProps } from "@osu/react-ui";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { ACTION_STATUS } from "../../util/constants";

function AuthButton(props = {}) {
  const { logoutAsStudentProxy, resetStudentProxyLogout, status, studentProxyLoginStatus, studentProxyLogoutStatus, user, ...rest } = props;
  const { isProxy = false, name: userName, proxy = {} } = user || {};
  const { name: proxyName } = proxy;
  const remainingProps = omitReduxProps(rest);
  const navigate = useNavigate();
  const logoutProxy = () => {
    navigate("/"); // navigate to home to avoid page errors for unauthorized
    logoutAsStudentProxy();
  };

  // when student proxy logout succeeds, reset state
  useEffect(() => {
      if(studentProxyLogoutStatus === ACTION_STATUS.SUCCESS) resetStudentProxyLogout();
  }, [resetStudentProxyLogout, studentProxyLogoutStatus]);

  if([status, studentProxyLoginStatus].includes(ACTION_STATUS.LOADING)) {
    return (<Mui.Typography variant="body2" {...remainingProps}>Logging in</Mui.Typography>);
  }

  if(studentProxyLogoutStatus === ACTION_STATUS.LOADING) {
    return (<Mui.Typography variant="body2" {...remainingProps}>Logging out</Mui.Typography>);
  }

  if([ACTION_STATUS.SUCCESS, ACTION_STATUS.UNAUTHORIZED].includes(status)) {
    if(isProxy === true) {
      return (
        <Mui.Box alignItems="center" display="flex" flexWrap= "wrap">
          <Mui.Box marginRight="0.5rem">
            <Mui.Typography variant="body2" sx={{ overflowWrap: "anywhere" }}>{proxyName} as {userName}</Mui.Typography>
          </Mui.Box>
          <Mui.Box>
            <Mui.FormControl>
              <Mui.InputLabel id="logout-select-label">Log Out</Mui.InputLabel>
              <Mui.Select id="logout-select" labelId="logout-select-label" label="Log Out" sx={{ minWidth: "6.3rem" }}>
                <Mui.MenuItem onClick={() => logoutProxy()}>Log Out Student Proxy</Mui.MenuItem>
                <Mui.MenuItem component={RouterLink} to="/logout">Log Out</Mui.MenuItem>
              </Mui.Select>
            </Mui.FormControl>
          </Mui.Box>
        </Mui.Box>
      );
    } else {
      return (
        <Mui.Box sx={{ alignItems: "center", display: "flex", flexWrap: "wrap", flexDirection: "row" }} {...remainingProps}>
          {userName && 
            <Fragment>
              <Mui.Typography variant="body2" sx={{ overflowWrap: "anywhere" }}>{userName}</Mui.Typography>
              <Mui.Typography variant="body2">&nbsp;|&nbsp;</Mui.Typography>
            </Fragment>
          }
          <Mui.Box sx={{ width: "3.8rem" }}>
            <Mui.Link component={RouterLink} to="/logout">Log Out</Mui.Link>
          </Mui.Box>
        </Mui.Box>
      );
    }
  }

  return (<Mui.Link component={RouterLink} to="/login">Log In</Mui.Link>);
}

AuthButton.defaultProps = {
  color: "inherit",
};

export default AuthButton;